import { MakeGenerics } from '@tanstack/react-location';

export enum MainRoute {
  Any = '/*',
  Root = '/',
  Scheduler = 'scheduler',
  Forms = 'forms',
  OnlineSchedulerDigitalForms = 'os',

  Error400 = 'error400',
  Error403 = 'error403',
}

export enum SchedulerParam {
  uuid = ':uuid',
}

export enum FormsParam {
  uuid = ':uuid',
}

export enum OnlineSchedulerDigitalFormsParam {
  uuid = 'os/:uuid',
}

export type LocationGenerics = MakeGenerics<Record<string, never>>;
